import React from "react";
import { Form } from "tabler-react";

export default function ContextServicePills({ contexts, onSelect }) {
  if (!contexts || !contexts.length) {
    return null;
  }

  return (
    <Form.Group label="Service" className="pull-right">
      <Form.SelectGroup canSelectMultiple pills>
        {contexts.map((val, index) => (
          <Form.SelectGroupItem
            key={index}
            label={val.value}
            name={val.key}
            value="HTML"
            onClick={() => onSelect(val.key)}
          />
        ))}
      </Form.SelectGroup>
    </Form.Group>
  );
}
